
import { Component, OnInit } from '@angular/core';
import { CommonFunctionService, UserPOSData} from '../../../../services/Common/common-function.service';
import { FormControl, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { OrderService } from 'src/app/POS/POSServices/Setup/order.service';
const swal = require('sweetalert');

//import { Role } from './../../settings/view-userdetails/view-userdetails.component';

@Component({
  selector: 'app-order',
  templateUrl: './order.component.html',
  styleUrls: ['./order.component.scss']
})
export class OrderComponent implements OnInit {
  vieworder:boolean=false;
  merchantdata: UserPOSData ;
  isNeworder: boolean = true;
  isUpdateorder: boolean = false;
  rows;
  AutoMaticGroupSimilarItmes:boolean=false;
  AllowNotesOnOrders:boolean=false;
  
  
//this variables are not use full but some changes are thie that reson this varibles are not commented
customerId = new FormControl("", [Validators.required]);
firstName = new FormControl("", [Validators.required, Validators.maxLength(20), Validators.minLength(1), Validators.pattern("^(?! )[a-zA-Zs ]*$")]);
lastName = new FormControl("", [Validators.required, Validators.maxLength(20), Validators.minLength(1), Validators.pattern("^(?! )[a-zA-Zs ]*$")]);
employeeId= new FormControl("", [Validators.required]);
PassCode=new FormControl("", [Validators.required]);
email= new FormControl("", [Validators.required]);
phoneNo= new FormControl("", [Validators.required]);
address= new FormControl("", [Validators.required]);
role= new FormControl("", [Validators.required]);
passCode= new FormControl("", [Validators.required]);
manager= new FormControl("", [Validators.required]);
nickName= new FormControl("", [Validators.required]);
id= new FormControl("", [Validators.required]);
ContactPerference  = new FormControl("", [Validators.required]);


Price= new FormControl("", [Validators.required]);
PriceType= new FormControl("", [Validators.required]);
Taxes= new FormControl("", [Validators.required]);
ProductCode= new FormControl("", [Validators.required]);
Sku= new FormControl("", [Validators.required]);

  
  constructor( private router: Router,
    private activatedRoute: ActivatedRoute,
    private service: OrderService,
    private commonfunction: CommonFunctionService) { }

  ngOnInit() {
    this.merchantdata = this.commonfunction.getUserPOSData();
    this.getGeorderDetails();
  }


 
  
  getGeorderDetails() {
    let form = { merchantKeyId: "", id: "", PosSubscriptionId:"" };
    this.activatedRoute.params.subscribe(params => {
      console.log(params["id"]);
      console.log(params["merchantKeyId"]);
      form.id = params["id"];
      form.merchantKeyId = params["merchantKeyId"];
      form.PosSubscriptionId  = this.merchantdata.PosSubscriptionId;
      console.log("formdata---" + form);
    });   
    
    
      this.service.GetOrderSetupDetail(form).subscribe(result => {    
      console.log("result.Id---" + result);
    
          if (result.Id>0) {

        this.AutoMaticGroupSimilarItmes=result.AutoMaticGroupSimilarItmes;
        this.AllowNotesOnOrders=result.AllowNotesOnOrders;
        this.vieworder=true;
        this.isUpdateorder = false;
        this.isNeworder = false;
        this.rows = result;      
      } else {
        this.vieworder=false;
        this.isUpdateorder = false;
        this.isNeworder = true;
      }
    });
 
  }


showhide()
  {
    this.AutoMaticGroupSimilarItmes = !this.AutoMaticGroupSimilarItmes ;
   }
  showhide1()
  {
    this.AllowNotesOnOrders = !this.AllowNotesOnOrders ;
   }
   editorder()
   {
        this.vieworder=false;
        this.isUpdateorder = true;
        this.isNeworder = false;
   }


   isFormValid()
   {
    return  (this.Price.invalid && (this.Price.dirty || this.Price.touched)) || 
    (this.PriceType.invalid && (this.PriceType.dirty || this.PriceType.touched) ) ||
    (this.Taxes.invalid && (this.Taxes.dirty || this.Taxes.touched) )||
    (this.ProductCode.invalid && (this.ProductCode.dirty || this.ProductCode.touched) )||
     (this.Sku.invalid && (this.Sku.dirty || this.Sku.touched))
   }

  newOrder() {
   
    let form = {
      PosSubscriptionId:"",
      CustomerId :"",
       AutoMaticGroupSimilarItmes :false,
  
      AllowNotesOnOrders  :false,
      
      };
    form.AutoMaticGroupSimilarItmes = this.AutoMaticGroupSimilarItmes;
    form.AllowNotesOnOrders  = this.AllowNotesOnOrders;
    let merchantdata: UserPOSData = this.commonfunction.getUserPOSData();
    form.CustomerId = merchantdata.PosSubscriptionId;
    form.PosSubscriptionId = merchantdata.PosSubscriptionId;
    
    this.service.AddOrderSetup(form).subscribe(result => {
      console.log(" result - ", result);
      if (result != null) {
        // swal("Added", "Order Setting Added Successfully !", "success");
        // this.router.navigate(["/pos/order/new"]);
        this.openConfirmationDialog();
        // window.location.reload();
    }
    });
  }
  openConfirmationDialog() {
    
    swal({
      title: 'Order Setting Added Successfully !',
      text: '',
      icon: 'success',
      buttons: {
        
          confirm: {
              text: 'Ok',
              value: true,
              visible: true,
              className: "",
              closeModal: true
          }
      }
  }).then((isConfirm) => {
      if (isConfirm) {
      window.location.reload();
      }
    
  });
  
  }


  UpdateopenConfirmationDialog() {
    
        swal({
          title: 'Order Setting Updated Successfully !',
          text: '',
          icon: 'success',
          buttons: {
            
              confirm: {
                  text: 'Ok',
                  value: true,
                  visible: true,
                  className: "",
                  closeModal: true
              }
          }
      }).then((isConfirm) => {
          if (isConfirm) {
          window.location.reload();
          }
        
      });
      
      }
    
  
  updateOrder()
  {
    let form = {
      PosSubscriptionId:"",
      AutoMaticGroupSimilarItmes  :false,
      AllowNotesOnOrders  :false,
       CustomerId :"",
      id:""
      };
     form.AutoMaticGroupSimilarItmes = this.AutoMaticGroupSimilarItmes;
    form.AllowNotesOnOrders = this.AllowNotesOnOrders;
    form.id=this.rows.Id;

    let merchantdata: UserPOSData = this.commonfunction.getUserPOSData();
    form.CustomerId = merchantdata.PosSubscriptionId;
    form.PosSubscriptionId = merchantdata.PosSubscriptionId;
   
    this.service.UpdateOrderSetup(form).subscribe(result => {
      console.log(" result - ", result);
      if (result != null) {
        this.UpdateopenConfirmationDialog();
        // swal("Updated", "Order Setting Updated Successfully !", "success");
        // this.router.navigate(["/pos/order/new"]);
        // swal("Updated", "Order Setting Updated Successfully !", "success"); 
        // this.router.navigate(["/pos/order/new"]);
        // window.location.reload();
        
      }
    });
  }


}

